import React from 'react'
import Box from '@material-ui/core/Box'
import Paper from '@material-ui/core/Paper'
import Button from '@material-ui/core/Button'
import Grid from '@material-ui/core/Grid'
import { get } from 'lodash'

function Card(props) {
  return (
    <Box component={Paper} p={2} elevation={0} variant="outlined">
      <Box mb={1} color="text.secondary">
        Pharmacy • {get(props, 'mall.pharmacy_license.type')} {get(props, 'mall.pharmacy_license.number')}/
        {get(props, 'mall.pharmacy_license.year')}
      </Box>
      <Box fontSize="16px">{get(props, 'mall.name')}</Box>
      <Box mt={5}>
        {get(props, 'first_name')} {get(props, 'last_name')}
      </Box>
      <Box>{get(props, 'mobile')}</Box>
      <Box mt={1} mb={2} minHeight="64px">
        {get(props, 'mall.shipping_address.line1')} {get(props, 'mall.shipping_address.sub_district')}{' '}
        {get(props, 'mall.shipping_address.district')} {get(props, 'mall.shipping_address.province')}{' '}
        {get(props, 'mall.shipping_address.postal_code')}
      </Box>
      <Grid container spacing={2}>
        <Grid item xs={4}>
          <Button
            fullWidth
            variant="contained"
            size="small"
            disableElevation
            onClick={props.onDeny(props._id, get(props, 'mall.name'))}
          >
            Deny
          </Button>
        </Grid>
        <Grid item xs={8}>
          <Button
            fullWidth
            color="primary"
            variant="contained"
            size="small"
            disableElevation
            onClick={props.onApprove(props._id, get(props, 'mall.name'))}
          >
            Approve
          </Button>
        </Grid>
      </Grid>
    </Box>
  )
}

export default Card
